<template>
  <div>
  <!--  <AboutBanner :content="banners[0].details" :title="banners[0].title" :img="banners[0].photo_file"/>-->
  
    <div class="mt-16" style="margin-top: 100px;">
      <v-container>
        <v-row>
          <v-col v-for="(item,i) in galleryItem.topics" :key="i" cols="6">
            <GlassGalleryItem :item="item"/>
          </v-col>
        </v-row>
      </v-container>
  
      <div v-if="current<total"   @click="page++" class="d-flex justify-center">
        <div style="background-color: #74B73B; width: 200px; height: 44px" class="pointer d-flex justify-center align-center">
          <p class="white--text">مشاهده موارد بیشتر</p>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import GlassGalleryItem from "./components/GlassGalleryItem";
  import {mapState} from "vuex";
  import AboutBanner from "../../About/Components/AboutBanner";
  
  export default {
    name: "baseGallery",
    components: {AboutBanner, GlassGalleryItem},
    created() {
      if (this.banners==null){
        this.$store.dispatch('glassManagement/getGlassBanners');
      }
      this.$store.dispatch('glassManagement/getGlassGallery',{
        page:this.page
      }).then(
          ()=>{
            this.total+= this.galleryItem.total_count;
            this.current = this.galleryItem.topics.length;
          }
      );
    },
    computed:{
      ...mapState({
        galleryItem: state => state.glassManagement.glassGallery,
        banners: state => state.glassManagement.glassBanners,
      })
    },
    data(){
      return{
        page:1,
        total:0,
        current:0,
      }
    },
    watch:{
      page(){
        this.$store.dispatch('lightBlocksManagement/getBlockGallery',{
          page:this.page
        }).then(
            () =>{
              this.current = this.galleryItem.topics_count;
            }
        );
      }
    }
  }
  </script>
  
  <style scoped>
  .date-box {
    padding: 0 10px;
    text-align: center;
    position: absolute;
    bottom: 0;
    color: white;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.6);
  }
  
  .g-box:hover > * > * > .date-box {
    background-color: #0846be;
    transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
  }
  
  .date-box > * {
    color: white;
    font-size: 16px !important;
  }
  </style>